import { render, staticRenderFns } from "./Employee Documents.vue?vue&type=template&id=4d13125b"
import script from "./Employee Documents.vue?vue&type=script&lang=js"
export * from "./Employee Documents.vue?vue&type=script&lang=js"
import style0 from "./Employee Documents.vue?vue&type=style&index=0&id=4d13125b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports